import type { TemplateResolveApiArg } from '@/services/api/generated/templatesV2Service';
import { useTemplateResolveQuery } from '@/services/api/generated/templatesV2Service';

export interface UseResolvedTemplateOptions {
  /** Template category to resolve */
  category: TemplateResolveApiArg['category'];
  /** Firm ID for firm-specific resolution */
  firmId?: string;
  /** Skip the query (e.g. when category is not yet selected) */
  skip?: boolean;
}

export function useResolvedTemplate({
  category,
  firmId,
  skip = false,
}: UseResolvedTemplateOptions) {
  const { data, isLoading, error } = useTemplateResolveQuery(
    { category, firmId },
    { skip },
  );

  return {
    /** The resolved default template, or undefined if none */
    template: data?.template ?? undefined,
    /** Which tier the resolution came from (e.g. "firm", "global") */
    sourceTier: data?.source_tier ?? undefined,
    /** Loading state */
    isLoading,
    /** Error state */
    error,
  };
}
